
<div class="card-container ciclo-escolar">
    <mat-card class="example-card">
        <mat-card-header>
            <mat-card-title>Gestor académico</mat-card-title>
            <mat-card-subtitle>Gestión y control académico</mat-card-subtitle>
        </mat-card-header>
    </mat-card>
</div>

